export default "__VITE_ASSET__925df602__"